export default {
  crudEditDetail: {
    type: Boolean,
    default: false,
  },
  showSendIbpHint: {
    type: Boolean,
    default: true,
  },
  setScope: {
    type: String,
    default: '',
  },
  onSide: {
    type: Boolean,
    default: false,
  },
  saveTipFlag: {
    type: Boolean,
    default: true,
  },
  businessFlowUrl: {
    type: String,
    default: 'rest/main/order/track/queryByOrderId',
  },
  batchPriceUrl: {
    type: String,
    default: 'rest/main/order/bill/batchPrice',
  },
  sendIbpHintUrl: {
    type: String,
    default: '',
  },
  businessFlow: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  // 获取编辑内容
  urlGetOfEdit: {
    type: String,
    default: null,
  },
  // 获取编辑内容的请求方式
  urlGetOfEditMethod: {
    type: String,
    default: 'get',
  },
  // 获取编辑内容的参数
  urlGetOfEditParamter: {
    type: Object,
    default: null,
  },
  //如果没有配置 urlGetOfEdit  则需要进行配置initFormData 为空  否则会出现表单不会显示出来的问题
  initFormData: {
    type: Object,
    default: null,
  },
  // 保存地址  "/rest/main/system/user/save"
  urlSave: {
    type: String,
    default: null,
  },
  // 监听item的input事件变化钩子函数
  watchInputHandle: {
    type: Object,
    default: null,
  },
  // 表单定义配置Url
  formItemsDefUrl: {
    type: String,
    default: null,
  },
  // 表单定义配置
  formItemsDef: {
    type: Array,
  },
  // 表单Form配置
  propsForm: {
    type: Object,
    default: () => {
      return {
        // 是否开启行内表单模式
        inline: true,
        // 表单域标签的位置，可选值为 left、right、top
        labelPosition: 'top',
        // //表单域标签的宽度，所有的 FormItem 都会继承 Form 组件的 label-width 的值
        // labelWidth: 0,
        // 是否显示校验错误信息
        showMessage: true,
        // 原生的 autocomplete 属性，可选值为 off 或 on
        autocomplete: 'off',
      }
    },
  },
  // 菜单按钮获取URL
  buttonMenuListUrl: {
    type: String,
    default: null,
  },
  tableParamName: {
    type: String,
    default: 'order',
  },
  needComputeCount: {
    type: Boolean,
    default: false,
  },
  useBackCount: {
    // 用于价格管理中反算
    type: String,
    default: null,
  },
  pDBusinessFlow: {
    // 盘点单的流程图
    type: Boolean,
    default: false,
  },
  getHistoryDataUrl: {
    type: String,
    default: null,
  },
  anchorGoTop: {
    type: Number,
    default: 151,
  },
  notUseKey: {
    type: Array,
    default: () => [],
  },
  topButtonSystems: {
    // 显示顶部按钮的  系统 逗号分隔的系统
    type: String,
    default: 'LINK, HBOX, MINK',
  },
  specialState: {
    //自定义的store初始状态
    type: Object,
    default: () => ({}),
  },
  specialMutations: {
    //自定义的store初始Mutations
    type: Object,
    default: () => ({}),
  },
  specialActions: {
    //自定义的store初始Actions
    type: Object,
    default: () => ({}),
  },
  formDataChangeItems: {
    //将formData的数据与items关联
    type: String,
    default: null,
  },
  extendCompile: Object,
  //显示二维码的字段
  qrcodePath: {
    type: String,
    default: 'order.code',
  },
  //是否在侧边显示单据二维码
  showQrcode: {
    type: Boolean,
    default: false,
  },
}
